import moment from 'moment-timezone';
export class TimeIntervalUtils {
  static readonly FORMAT_MAP = {
    day: 'MMM D, YYYY',
    month: 'MMM YYYY',
    week: 'MMM D, YYYY',
    quarter: 'Q YYYY',
    year: 'YYYY',
  };

  static formatTimeInterval(
    value: string,
    type: keyof typeof TimeIntervalUtils.FORMAT_MAP | string,
    timezone: string,
    weekOfLabel: string,
    invalidDateLabel: string,
    includeIntervalLabel: boolean = true
  ): string {
    if (value) {
      const convertedValue = isNaN(+value) ? value : +value;
      const momentDate = moment.tz(convertedValue, timezone);

      if (!momentDate.isValid()) {
        return `${invalidDateLabel}`;
      }

      const format = TimeIntervalUtils.FORMAT_MAP[type] ?? type;
      const returnValue = momentDate.format(format);
      return TimeIntervalUtils.getUnformattableValue(
        type,
        returnValue,
        weekOfLabel,
        includeIntervalLabel
      );
    }
  }

  static getUnformattableValue(
    type: keyof typeof TimeIntervalUtils.FORMAT_MAP | string,
    value: string,
    weekOfLabel: string,
    includeIntervalLabel: boolean = true
  ) {
    switch (type) {
      case 'quarter':
        return `Q${value}`;
      case 'week': {
        const weekFormat = TimeIntervalUtils.FORMAT_MAP['week'];
        const parsed = moment(value, weekFormat, true);
        if (!includeIntervalLabel) {
          return parsed.isValid() ? parsed.startOf('isoWeek').format(weekFormat) : value;
        }
        if (parsed.isValid()) {
          const weekStart = parsed.startOf('isoWeek');
          return `${weekOfLabel} ${weekStart.format(weekFormat)}`;
        }
        return `${weekOfLabel} ${value}`;
      }
      default:
        return value;
    }
  }
}
